import * as React from 'react';
import { composer } from '../../../component-decorators/composer';
import { Card } from 'wix-style-react';
export var RegularHeader = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t;
    return (React.createElement(Card.Header, { dataHook: 'installed-apps-title', title: t('manage-apps.regular-apps.card-header.title') }));
});
//# sourceMappingURL=regular.apps-section-header.js.map